import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { FileText, Info } from 'react-feather'
import { 
    CustomTableData,
    TooltipInformation,
    TooltipApprovalInfo,
    CustomDropDown
 } from 'common'


const AdminDepositTable = ({useFetchInit}) => {

    const {
        FetchData,
        Actions
    }= useFetchInit


    const { fetchAllDeposits } = FetchData
    const { deposits } = fetchAllDeposits

    const {
        handleClickFetchInfoDeposit,
        handleClickPrintDepositTicket
    } = Actions
  
    const columnConfig = [
        { 
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const {iddeposit, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                return(
                    <TooltipInformation 
                        idregistro={iddeposit}
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { 
            field: "deposito_fecha",
            headerName: "FECHA",
            minWidth: 130,
            maxWidth: 130,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
        },
        { field: "movimiento_tipo", headerName: "TIPO", minWidth: 220, filter: true },
        { field: "banco", headerName: "CUENTA", minWidth: 300, filter: true },
        { field: "boleta_numero", headerName: "No. BOLETA", minWidth: 180, filter: true },
        { field: "deposito_moneda", headerName: "MONEDA", minWidth: 130, filter: true },
        { field: "deposito_tipo_cambio", headerName: "CAMBIO", minWidth: 130, filter: true },
        { 
            field: "deposito_quetzal", headerName: "TOTAL (Q)", minWidth: 130, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "deposito_dolares", headerName: "TOTAL ($)", minWidth: 130, filter: true,
            cellRenderer: (params) => '$ ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 200,
            maxWidth: 200,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {

                if(params.value === 'APROBADO') return 'bg-success';
                if(params.value === 'PENDIENTE') return 'bg-warning';
                if(params.value === 'RECHAZADO') return 'bg-danger';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data

                return (
                    <TooltipApprovalInfo
                        texto_approval={value}
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                )

            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const {iddeposit} = params.data

                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickFetchInfoDeposit(iddeposit)}
                        >
                            <ListItemIcon> <Info color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickPrintDepositTicket(iddeposit)}
                        >
                            <ListItemIcon> <FileText color="black"/> </ListItemIcon>
                            <ListItemText primary="Recibo" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData 
                rowConfig={deposits}
                columnConfig={columnConfig}
            />
        </div>
    )
}

export{
    AdminDepositTable
}